import { render, staticRenderFns } from "./SingleInvoice.vue?vue&type=template&id=4bc8fb09&"
import script from "./SingleInvoice.vue?vue&type=script&lang=js&"
export * from "./SingleInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports